<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px'}" :bodyStyle="{paddingTop:'0px'}">
    <a-row slot="title">
      <a-col :span="24">
        <span>专题模板</span>
        <span class="tips">{{ subjectTemplateDto.subjectName }}</span>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <div class="link-class" v-if="specialLinkUrl">专题链接：{{ specialLinkUrl }}</div>
      <a-col :xxl="8" :xl="8" :lg="8" :sm="7" :md="10">
        <div class="projectone">
          <img :src="subjectTemplateDto.subjectBanner"/>
        </div>
      </a-col>
      <a-col :xxl="16" :xl="16" :lg="16" :sm="14" :md="14">
        <div class="thmemMain">
          <div class="themeNavInput">
            <span>专题名称：</span>
            <a-input v-model="subjectCustTitle" :maxLength="20" placeholder="不超过20个字"/>
          </div>
          <div class="themeNavInput mtop20">
            <span>推广语：</span>
            <a-input v-model="subjectCustPromotion" :maxLength="20" placeholder="请输入"/>
          </div>
          <div class="mtop20">
            <span>页面设置</span>
            <a-divider/>
          </div>
          <div class="dto-list" v-for="(item, index) in moduleDtoList" :key="index">
            <div class="mtop20" v-if="showModuleIndexName(item)">
              <span>模块{{ item.moduleIndex }}：{{ item.moduleIndexName }}</span>
            </div>
            <div class="mtop20" :class="item.moduleType != 3 ? 'flex' : ''">
              <div v-if="item.moduleType == 1">
                <span>类型：图片</span>
                <a-upload
                  name="file"
                  :before-upload="handleBeforeUploadImage"
                  :multiple="false"
                  :action="uploadFileUrl"
                  @change="file=> handleChange(file,index)"
                  :fileList="item.fileList"
                >
                  <a-button type="primary" style="margin: 0 15px"> 点击上传</a-button>
                  <span>素材尺寸:{{ item.imgSize }}</span>
                </a-upload>
              </div>
              <div class="flex-items-center"
                   v-if="item.canWriteModuleTitle&&(item.moduleType==3||item.moduleType==2||item.moduleType==5)">
                <div class="title">类型：文字</div>
                <a-input v-model="item.moduleCustName"
                         style="margin-left:20px;width: 200px"
                         :maxLength="8" :placeholder="item.moduleIndexName"/>
                <div class="el-upload__tip" style="width:120px">不超过8个字</div>
              </div>
              <div v-if="item.moduleType == 3" class="mtop20">
                <div><span>模块{{ item.moduleIndex }}：{{ item.moduleIndexName }}商品 </span></div>
                <div class="mtop20 flex-items-center">
                  <div class="title">类型：商品</div>
                  <a-select
                    v-model="item.productLinkedType"
                    style="width:140px;margin-left:20px;"
                    @change='e=>onModuleTypeChange(e,item,index)'
                    placeholder="请选择">
                    <a-select-option :value="0">关联单个商品</a-select-option>
                    <a-select-option :value="1">关联商品分组</a-select-option>
                  </a-select>
                  <a-button @click="getProductList(index,item)" style="margin-left: 20px">选择</a-button>&nbsp;&nbsp;
                  <span v-if='item.productGroupId'>绑定商品分组ID:{{ item.productGroupId }}</span>
                  <div v-else-if='item.productLinkedType===0' class="el-upload__tip">下方已选择商品拖动可排序</div>
                </div>
              </div>
              <div class="mtop20" v-if="item.moduleType == 3 && item.productLinkedType===0">
                <custom-dragging-table
                  :columns="getTableColumns()"
                  @draggable="(value) => onDraggableChange(index, value)"
                  :data-list="item.moduleDetailDtoList ? item.moduleDetailDtoList : []"
                >
                  <span slot="sortIdSlots" slot-scope="rowItem">
                    {{ rowItem.index + 1 }}
                  </span>
                  <span slot="typeSlots" slot-scope="rowItem">
                    {{ rowItem.record.moduleCatalogId | productTypeName }}
                  </span>
                  <div class="name-title" slot="moduleProName" slot-scope="rowItem">
                    <a-tooltip placement="topLeft">
                      <div slot="title">
                        <span>{{ rowItem.record.moduleProName }}</span>
                      </div>
                      {{ rowItem.record.moduleProName }}
                    </a-tooltip>
                  </div>
                  <span slot="action" slot-scope="rowItem">
                    <a-button type="link" @click="deleteList(rowItem.record, index)">移除</a-button>
                  </span>
                </custom-dragging-table>
              </div>
            </div>
            <div class="couponMain" v-if="item.moduleType == 5">
              <span>类型：优惠券</span>
              <a-button @click="openCouponList" style="margin-left: 20px">关联</a-button>
            </div>
            <div class="mtop20" v-if="item.moduleType == 5">
              <a-table
                :dataSource="chooseCouponList"
                :columns="getChooseCoupon()"
                :pagination="false"
                rowKey="couponId"
                columnWidth="700px"
              >
                <span slot="typeSlots" slot-scope="text, record">
                  {{ record.moduleCatalogId | ProductTypeName }}
                </span>
                <span slot="action" slot-scope="text, record">
                  <a-button type="link" @click="deleteCouponList(record)">移除</a-button>
                </span>
              </a-table>
            </div>
          </div>
          <div class="mtop20">
            <a-button type="primary" @click="submitData(false)" :loading="submitLoading1">保存并生成</a-button>
            <a-button @click="submitData(true)" style="margin-left:15px" :loading="submitLoading2">预览</a-button>
          </div>
        </div>
      </a-col>
    </a-row>

    <!--关联商品-->
    <selected-product-dialog
      title="选择商品"
      :show="showSelectedDialog"
      :itemNames="['search_proId', 'search_proName']"
      :query-params="selectedQueryParams"
      params-path="user/home/getSelectProductAllList"
      base-key="userUrl"
      row-key="proId"
      :width="900"
      ref="pageList"
      :page-size="5"
      @close="showSelectedDialog = false"
      :columns="getGoodsColumns()"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="selectedFormLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="selectedFormLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <div slot="proName" slot-scope="rowItem" class="ellipsis-text">
        <a-tooltip placement="topLeft">
          <div slot="title">
            <span>{{ rowItem.text }}</span>
          </div>
          {{ rowItem.text }}
        </a-tooltip>
      </div>
      <div slot="footer">
        <div class="dialogBtn">
          <a-button @click="showSelectedDialog = false" style="margin-right: 15px">取消</a-button>
          <a-button type="primary" @click="confirmProduct">确定</a-button>
        </div>
      </div>
    </selected-product-dialog>

    <!--关联优惠券-->
    <selected-product-dialog
      title="选择优惠券"
      :show="showCouponDialog"
      :itemNames="['search_couponName']"
      :requestPromise="loadCouponPromise"
      :queryParams="selectedParams"
      :width="900"
      ref="pageList"
      :page-size="5"
      @close="showCouponDialog = false"
      :columns="getCouponColumns()"
    >
      <a-form-item label="名称" slot="search_couponName" v-bind="selectedFormLayout">
        <a-input v-model="selectedParams.couponName" style="width: 170px" placeholder="请输入优惠券名称"></a-input>
      </a-form-item>
      <div slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="couponChoose(rowItem)">选择</a-button>
      </div>
    </selected-product-dialog>
    <!--选择分组-->
    <selected-product-dialog
      ref="groupDialog"
      :col="2"
      :show="showSelectedGroupDialog"
      :itemNames="['search_proName']"
      :query-params="selectedQueryGroupParams"
      :request-promise="getGroupRequest"
      @close="showSelectedGroupDialog=false"
      :columns="getGroupColumns()"
    >
      <a-form-item
        label="商品分组名称"
        slot="search_proName"
        :wrapperCol="{span:18}"
        :labelCol="{span:6}">
        <a-input
          v-model="selectedQueryGroupParams.groupName"
          style="width: 100%"
          placeholder="请输入商品分组名称"
        ></a-input>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedGroupResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import CustomPageList from '../../../../customComponents/CustomPageList'
import searchForm from '../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../utils/mixins/formMixins'
import SpecialMixins from './SpecialMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import EditableCell from '../../../platform/component/editableCell'
import CustomDraggingTable from '@/customComponents/CustomDraggingTable/CustomDraggingTable'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'ServiceThemeTemplate',
  mixins: [searchForm, formMixin, SpecialMixins],
  components: { CustomPageList, SelectedProductDialog, EditableCell, CustomDraggingTable },
  data() {
    return {
      subjectTemplateDto: {}, // '模板的相关数据'
      subjectId: this.$route.query.subjectId, // '专题 id'
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      subjectMerchantId: this.$route.query.subjectMerchantId, // '专题 对应的 id'
      h5DomainUrl: this.$route.query.domainUrl,
      moduleDtoList: [], // '获取 专题的配置信息拼接页面'
      subjectCustTitle: '',
      submitLoading1: false,
      submitLoading2: false,
      queryParams: {},
      uploadFileUrl: this.getAppConfig().baseUrl + '/base/upload', //文件上传地址
      listData: [], // '投放设置数据'
      showSelectedDialog: false,
      selectedQueryParams: {
        proName: '',
        proId: '',
        shelfStatus: '1'
      },
      selectedFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      selectedRowKeys: [],
      proIdList: [],
      indexKey: 0,
      textareaText: '',
      showCouponDialog: false,
      selectedParams: {
        couponMerchantId: this.$store.getters.userInfo.merchantId,
        couponName: '', // 优惠券名称
        specialId: this.$route.query.subjectId,
        couponPlatformId: this.getPlatformConfig().platformId
      },
      chooseCouponList: [],
      loadCouponPromise: params => this.getCouponListPromise(params),
      specialLinkUrl: '',
      subjectCustPromotion: '',
      showSelectedGroupDialog: false,
      selectedQueryGroupParams: { groupStatus: 1 }
    }
  },
  created() {
  },
  mounted() {
    this.getMerchantSubjectTemplate()
  },
  methods: {
    getCouponListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingList', params)
    },
    getMerchantSubjectTemplate() {
      //制作商户专题查询接口
      let subjectMerchantId = this.$route.query.subjectMerchantId
      let params = {}
      let url = ''
      if (!subjectMerchantId) {
        url = 'getSubjectMerchantDetail'
        params = {
          subjectId: this.subjectId,
          merchantId: this.merchantId,
          platformId: this.platformId
        }
      } else {
        url = 'getBackstageSubjectMerchant'
        params = {
          subjectmerchantId: subjectMerchantId,
          merchantId: this.merchantId,
          platformId: this.platformId
        }
        let h5Params = {
          p: `${1}_${this.merchantId}_${this.merchantId}`,
          subjectMerchantId: subjectMerchantId
        }
        this.specialLinkUrl = RouterSwitchHelper.getProductSpecialPathUrl(this.h5DomainUrl, h5Params)
      }
      this.getHttpServices().getServerApiService().post(url, params).then(res => {
        this.subjectTemplateDto = res.subjectTemplateDto
        this.subjectCustPromotion = res.subjectCustPromotion
        let moduleDtoList = res.moduleDtoList
        moduleDtoList.forEach((item, index) => {
          if (item.moduleDetailDtoList && item.moduleDetailDtoList.length > 0) {
            let obj = {}
            let peon = item.moduleDetailDtoList.reduce((cur, next) => {
              obj[next.moduleProId] ? '' : (obj[next.moduleProId] = true && cur.push(next))
              return cur
            }, []) //设置cur默认类型为数组，并且初始值为空的数组
            this.getLogUtils().logWithTag('peon', peon)
            item.moduleDetailDtoList = peon
            if (item.moduleType == 1) {
              this.getLogUtils().logWithTag('更新', item)
              let list = []
              if (item.moduleDetailDtoList[0].moduleBanner) {
                let uploadObj = {
                  uid: '-1',
                  name: item.moduleDetailDtoList[0].moduleBanner,
                  status: 'done',
                  url: item.moduleDetailDtoList[0].moduleBanner
                }
                list.push(uploadObj)
              }
              this.$set(item, 'fileList', list)
            }
            if (item.moduleType == 5) {
              item.moduleDetailDtoList.forEach((v, k) => {
                this.chooseCouponList.push({
                  couponId: v.moduleProId,
                  couponName: v.moduleProName,
                  couponAmout: v.moduleCatalogStr
                })
              })
            }
          } else {
            item.moduleDetailDtoList = []
            if (item.moduleType == 1) {
              let obj = new Object()
              obj.moduleBanner = ''
              obj.moduleCatalogId = ''
              obj.moduleProId = ''
              obj.moduleProName = ''
              obj.moduleSort = ''
              item.moduleDetailDtoList.push(obj)
            }
            this.$set(item, 'fileList', [])
          }
        })
        this.subjectCustTitle = res.subjectCustTitle
        this.moduleDtoList = moduleDtoList
        this.getLogUtils().logWithTag('moduleDtoList', this.moduleDtoList)
      })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleChange(file, index) {
      //  图片上传成功
      this.getLogUtils().logWithTag('图片下标', index)
      if (file.file.status != 'removed') {
        const url = this.getLatestUrlFromFileList(file.fileList)
        this.getLogUtils().logWithTag('上传图片URL', url)
        this.moduleDtoList[index].fileList = [...file.fileList]
        this.moduleDtoList[index].fileList = this.moduleDtoList[index].fileList.slice(-1)
        this.moduleDtoList[index].moduleDetailDtoList[0].moduleBanner = url
      } else {
        this.moduleDtoList[index].fileList = []
        this.moduleDtoList[index].moduleDetailDtoList[0].moduleBanner = ''
      }
      this.getLogUtils().logWithTag('moduleDtoList', this.moduleDtoList)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.proIdList = selectedRows
    },
    getProductList(index, item) {

      // this.showSelectedDialog = true;
      this.proIdList = []
      this.selectedRowKeys = []
      this.indexKey = index
      if (String(item.productLinkedType) === '1') {
        this.showSelectedGroupDialog = true
      } else {
        this.showSelectedDialog = true
      }
    },
    confirmProduct() {
      if (this.proIdList.length < 1) {
        this.$message.error('请选择要操作的商品')
        return
      }
      this.showSelectedDialog = false
      let indextype = this.indexKey
      this.proIdList.forEach((item, index) => {
        this.moduleDtoList[indextype].moduleDetailDtoList.forEach((v, k) => {
          if (v && v.moduleProId && item.moduleProId == v.moduleProId) {
          } else {
            this.moduleDtoList[indextype].moduleDetailDtoList.slice(k, 1)
          }
        })
      })
      this.proIdList.forEach((item, index) => {
        let obj = new Object()
        obj.moduleProId = item.proId
        obj.moduleCatalogId = item.proCatalogId
        obj.moduleProName = item.proName
        obj.moduleCatalogStr = item.proCatalogName
        obj.moduleProCityName = item.proCityName
        this.moduleDtoList[indextype].moduleDetailDtoList.push(obj)
      })
      let obj = {}
      let peon = this.moduleDtoList[indextype].moduleDetailDtoList.reduce((cur, next) => {
        obj[next.moduleProId] ? '' : (obj[next.moduleProId] = true && cur.push(next))
        return cur
      }, []) //设置cur默认类型为数组，并且初始值为空的数组
      this.moduleDtoList[indextype].moduleDetailDtoList = peon
      this.getLogUtils().logWithTag('moduleDetailDtoList', this.moduleDtoList[indextype].moduleDetailDtoList)
    },
    onDraggableChange(index, sortList) {
      this.moduleDtoList[index].moduleDetailDtoList = sortList
      this.getLogUtils().logWithTag('index', index)
      this.getLogUtils().logWithTag('sortList', sortList)
    },
    onCellChange(record, value, index) {
      //key:当前Key,value:输入值，index:当前操作列表
      //moduleProId
      let arr = this.moduleDtoList[index].moduleDetailDtoList
      arr[record.key].key = Number(value) || 0
      arr.sort(function(a, b) {
        return a.key - b.key
      })
      arr.forEach((item, index) => {
        item.key = index
      })
      this.moduleDtoList[index].moduleDetailDtoList = arr
    },
    deleteList(record, index) {
      let arr = this.moduleDtoList[index].moduleDetailDtoList
      arr.forEach((item, index) => {
        if (item.moduleProId === record.moduleProId) {
          arr.splice(index, 1)
        }
      })
      this.moduleDtoList[index].moduleDetailDtoList = arr
    },
    // '保存商户的专题'
    submitData(flag) {
      if (!this.subjectCustTitle) {
        this.$message.error('专题名称不能为空')
        return
      }
      if (!this.subjectCustPromotion) {
        this.$message.error('推广语不能为空')
        return
      }
      let data = {}
      data.merchantId = this.merchantId
      data.platformId = this.platformId
      data.subjectId = this.subjectId
      data.subjectCustPromotion = this.subjectCustPromotion
      data.subjectmerchantId = this.subjectMerchantId
      if (this.chooseCouponList && this.chooseCouponList.length > 0) {
        let arr = []
        this.chooseCouponList.forEach((c, key) => {
          arr.push({ moduleProId: c.couponId })
        })
        this.moduleDtoList.forEach((v, k) => {
          if (v.moduleType == 5) {
            v.moduleDetailDtoList = arr
          }
        })
      } else {
        this.moduleDtoList.forEach((v, k) => {
          if (v.moduleType == 5) {
            v.moduleDetailDtoList = []
          }
        })
      }
      data.moduleDtoList = this.moduleDtoList
      this.moduleDtoList.forEach((item, index) => {
        let obj = {}
        let peon = item.moduleDetailDtoList.reduce((cur, next) => {
          obj[next.moduleProId] ? '' : (obj[next.moduleProId] = true && cur.push(next))
          return cur
        }, []) //设置cur默认类型为数组，并且初始值为空的数组
        item.moduleDetailDtoList = peon
        delete item.fileList
      })
      data.subjectTemplateDto = this.subjectTemplateDto
      data.subjectCustTitle = this.subjectCustTitle
      this.submitLoading1 = true
      this.submitLoading2 = true
      this.getHttpServices().getServerApiService().post('saveOrUpdateSubjectMerchant', data).then(res => {
        this.$message.success('专题制作成功')
        if (!flag) {
          this.goStyleService()
        } else {
          this.subjectMerchantId = res
          this.goH5SpecialUrl(res)
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => {
        this.submitLoading1 = false
        this.submitLoading2 = false
      })
    },
    goStyleService() {
      this.$router.push({
        name: 'StyleService',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    openCouponList() {
      this.showCouponDialog = true
    },
    couponChoose(rowItem) {
      if (this.chooseCouponList.length < 10) {
        if (this.chooseCouponList.length > 0) {
          let flag = false
          this.chooseCouponList.map(item => {
            if (item.couponId == rowItem.record.couponId) {
              this.$message.error('请勿重复添加优惠券')
              flag = true
            }
          })
          if (!flag) {
            this.chooseCouponList.push(rowItem.record)
            this.showCouponDialog = false
          }
        } else {
          this.chooseCouponList.push(rowItem.record)
          this.showCouponDialog = false
        }
      } else {
        this.$message.error('最多添加10个优惠券')
      }
    },
    deleteCouponList(record) {
      if (this.chooseCouponList.length > 0) {
        const tags = this.chooseCouponList.filter(tag => tag.couponId !== record.couponId)
        this.chooseCouponList = tags
      }
    },
    //是否展示标题
    showModuleIndexName(data) {
      if (data.moduleType == 3) {
        if (data.canWriteModuleTitle) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    //预览H5商城路径url
    goH5SpecialUrl(subjectMerchantId) {
      if (subjectMerchantId) {
        let params = {
          p: `${1}_${this.merchantId}_${this.merchantId}`,
          subjectMerchantId: subjectMerchantId
        }
        let domainUrl = this.getAppConfig().platformConfig.h5Url
        let url_page = RouterSwitchHelper.getProductSpecialPathUrl(domainUrl, params)
        window.open(url_page)
      } else {
        this.$message.error('预览错误，请联系管理员')
      }
    },
    //表格头部
    getTableColumns() {
      return [
        {
          title: '排序',
          dataIndex: 'iconSort',
          scopedSlots: { customRender: 'sortIdSlots' },
          width: '50px'
        },
        {
          title: '商品ID',
          dataIndex: 'moduleProId',
          width: '100px'
        },
        {
          title: '商品类型',
          dataIndex: 'typeSlots',
          scopedSlots: { customRender: 'typeSlots' },
          width: '85px'
        },
        {
          title: '商品名称',
          dataIndex: 'moduleProName',
          scopedSlots: { customRender: 'moduleProName' },
          width: '40%'
        },
        {
          title: '城市',
          dataIndex: 'moduleProCityName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '80px',
          fixed: 'right'
        }
      ]
    },
    //选择产品弹窗header
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          scopedSlots: { customRender: 'proName' },
          width: '300px'
        },
        {
          title: '商品分类',
          dataIndex: 'proCatalogName',
          width: '100px'
        },
        {
          title: '省份',
          dataIndex: 'proProvinceName'
        },
        {
          title: '城市',
          dataIndex: 'proCityName'
        },
        {
          title: '状态',
          dataIndex: 'modularTitle'
        }
      ]
    },
    //优惠券
    getCouponColumns() {
      return [
        {
          title: '优惠券Id',
          dataIndex: 'couponId',
          width: '100px'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          width: '250px'
        },
        {
          title: '优惠券金额',
          dataIndex: 'couponAmout',
          width: '140px'
        },
        {
          title: '使用类型',
          dataIndex: 'couponUseTypeStr'
        },
        {
          title: '状态',
          dataIndex: 'couponStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '100px',
          fixed: 'right'
        }
      ]
    },
    getChooseCoupon() {
      return [
        {
          title: '优惠券Id',
          dataIndex: 'couponId',
          width: '100px'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          width: '250px'
        },
        {
          title: '优惠券金额(元)',
          dataIndex: 'couponAmout',
          width: '140px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '100px',
          fixed: 'right'
        }
      ]
    },
    // 选择商品
    changeSelectPro(item) {
      this.getLogUtils().logWithTag('选择商品', item)
      this.ruleForm.iconLinked = item.proId
    },
    onModuleTypeChange(e, item, index) {
      item.moduleDetailDtoList = []
      item.productGroupId = undefined
      this.$set(this.moduleDtoList, index, item)
    },
    onSelectedGroupResult(item) {
      let selectedItem = this.moduleDtoList[this.indexKey]
      selectedItem.productGroupId = item.groupId
      this.$set(this.moduleDtoList, this.indexKey, selectedItem)
      this.showSelectedGroupDialog = false
    },
    getGroupRequest(params) {
      return this.getHttpServices().getProService().post('proGroup/findProGroupList', params)
    },
    getGroupColumns() {
      return [
        {
          title: 'id',
          dataIndex: 'groupId',
          width: '60px'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
@import '../../../CustomPage';

.projectLeft {
  span {
    display: block;
    font-size: 16px;
    margin-top: 15px;
  }

  img {
    width: 200px;
    height: 200px;
    display: block;
    margin-top: 15px;
  }

  p {
    color: #777;
  }
}

.projectone {
  height: 667px;
  overflow-y: scroll;

  img {
    max-width: 375px;
    width: 100%;
  }
}

.dialogBtn {
  display: flex;
  justify-content: flex-end;
}

.couponMain {
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;
}

.ml40 {
  margin-left: 40px;
}

.mtop20 {
  margin-top: 20px;
}

.flex-items-center {
  display: flex;
  align-items: center;
}

.name-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  width: 100%;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 300px
}

.tips {
  font-size: 14px;
  padding-left: 15px;
}

.link-class {
  line-height: 40px;
  padding: 0 10px;
  margin-bottom: 20px;
}
</style>